import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Stack, IconButton, Container } from "@mui/material";
import HouseOutlinedIcon from "@mui/icons-material/HouseOutlined";
import Person2Outlined from "@mui/icons-material/Person2Outlined";

import Logo from "../static/Images/logo.png"


const TopBar = () => {
  const navigate = useNavigate();

  return (
    <Box width="100%">
      <Stack
        width="100%"
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        className="relative px-2 sm:px-0 py-2 -mt-10"
      >
        <IconButton aria-label="" onClick={() => navigate("/dashboard")}>
          <HouseOutlinedIcon className="text-white " />
        </IconButton>
        
        <Box  className="absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2">
          <img
              src={Logo}
              onClick={() => navigate('/')}
              alt="thaml"
              width={75}
              height={32}
              className="cursor-pointer"
              loading="lazy"
            />
        </Box>
        <IconButton aria-label="" onClick={() => navigate("/ModifyDetails")}>
          <Person2Outlined className="text-white" />
        </IconButton>
      </Stack>
    </Box>
  )
}

export default TopBar